import { t } from "i18next";

export const APPLICATION_STATUS_OPTIONS = [
  { value: 1, label: "pending" },
  { value: 0, label: "completed" },
  { value: 99, label: "incart" },
  { value: -1, label: "cancelled" }, //cart counter over || user deletes from cart
];

export const APPLICATION_ITEM_STATUS_OPTIONS = [
  { value: "future", label: "future" },
  { value: "completed", label: "completed" },
  { value: "cancelled", label: "cancelled" },
];

export const APPLICATION_PAYMENT_STATUS_OPTIONS = [
  { value: "totally_paid", label: "totally_paid" },
  { value: "partially_paid", label: "partially_paid" },
  { value: "not_paid", label: "not_paid" },
  { value: "pending", label: "pending" },
];

export const APPLICATION_ITEM_PAYMENT_STATUS_OPTIONS = [
  { value: "totally_paid", label: "totally_paid" },
  { value: "not_paid", label: "not_paid" },
];

export const PLAYER_APPLICATION_TYPE_OPTIONS = [
  { value: "reservation", label: "timebooking" },
  { value: "reservationperiod", label: "period_group_trainings" },
  { value: "training", label: "occasional_group_trainings" },
  { value: "waitlist", label: "waitinglist" },
  { value: "pass", label: "pass" },
  { value: "ticket", label: "ticket" },
  { value: "tournamentapplication", label: "tournamentapplication" },
];

export const APPLICATION_TYPE_OPTIONS = [
  { value: "reservation", label: "timebooking" },
  { value: "reservationperiod", label: "period_group_trainings" },
  { value: "training", label: "occasional_group_trainings" },
  { value: "waitlist", label: "waitinglist" },
  { value: "pass", label: "pass" },
  { value: "ticket", label: "ticket" },
  { value: "select_from_the_list", label: "select_from_the_list" },
];

export const ORGANISER_APPLICATION_TYPE_OPTIONS = [
  { value: "tournamentapplication", label: "tournamentapplication" },
  { value: "select_from_the_list", label: "select_from_the_list" },
];

export const PAYMENT_TYPE_OPTIONS = [
  { id: 1, value: "pre_payment", label: "pre_payment" },
  { id: 2, value: "post_payment", label: "post_payment" },
];

export const PAYMENT_METHODS = [
  {
    id: 1,
    value: "onsite",
    label: "onsite_payment_title_new",
    icon: "bi:cash",
    description: "onthespot_payment_description_new",
  },
  {
    id: 2,
    value: "banktransfer",
    label: "banktransfer_payment_title",
    icon: "mdi:bank-transfer",
    description: "banktransfer_payment_description",
  },
  {
    id: 3,
    value: "creditcardbarion",
    label: "creditcard_payment_title",
    icon: "fluent:payment-16-filled",
    description: "credit_card_payment_description",
  },
];

export const availableTimesParams = {
  startTime: "04:00",
  endTime: "24:00",
  interval: "15:00",
};

export type ServiceKey =
  | "reservation"
  | "training"
  | "reservationperiod"
  | "passes"
  | "tickets"
  | "tournamentapplication"
  | "association_membership_fee";

export const serviceLabelMap: Record<ServiceKey, string> = {
  association_membership_fee: t("association_fees"),
  reservation: t("reservation"),
  training: t("occasional_group_trainings"),
  reservationperiod: t("period_group_trainings"),
  passes: t("passes"),
  tickets: t("tickets"),
  tournamentapplication: t("tournamentapplication"),
};
